import { Button, Modal, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { makeToasterErrorHandler } from "../../common/http/makeToasterErrorHandler";
import { extractErrorMessage } from "../../common/utils/axios.isAxiosError";
import { usePageToast } from "../../hooks/usePageToast";
import api from "../../services/api";
import { InputSection } from "../style/ProductCreateModal.styled";
import PageToaster from "../toaster/PageToaster";

interface ProductReplanishModalProps {
  open: boolean;
  onClose: () => void;
  onProductCreated: () => void;
  product?: any; // Dados do produto para edição (opcional)
}

const ProductReplanishModal: React.FC<ProductReplanishModalProps> = ({
  open,
  onClose,
  onProductCreated,
  product
}) => {
  const [productId, setProductId] = useState<number>(0);
  const [productName, setProductName] = useState("");
  const [productQuantity, setProductQuantity] = useState<number>(0);
  const [productNewQuantity, setProductNewQuantity] = useState<number>(0);

  const containerId = "toaster-product-replanish-modal";
  const { autoSuccess, autoError, autoInfo, autoWarn } = usePageToast(
    containerId,
    true
  );

  const handleHttpError = makeToasterErrorHandler(autoError);

  useEffect(() => {
    if (product) {
      console.log("product", product);
      setProductId(product.product_id);
      // Preenche os campos se estiver editando um produto
      setProductName(product.product_name || "");
      setProductQuantity(product.product_quantity || 0);
    } else {
      // Reseta os campos para criação
      setProductName("");
      setProductQuantity(0);
    }
  }, [product]);

  const clear = () => {
    setProductId(0);
    setProductName("");
    setProductQuantity(0);
    setProductNewQuantity(0);
  };

  const handleSubmit = async () => {
    try {
      await api.patch(
        `/products/${productId}/replenish-stock?quantity=${productNewQuantity}`
      );
      autoSuccess("Produtos  adicionados com sucesso!");
      onProductCreated();
      onClose();
      clear();
    } catch (error) {
      const msg = extractErrorMessage(error);
      console.error("Erro ao salvar produto:", error);
      autoError(`Erro: ${msg}`);
    }
  };

  return (
    <>
      <PageToaster containerId={containerId} />
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="create-product-modal"
      >
        <div
          style={{
            position: "absolute",

            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "var(--surface)",
            border: "1px solid var(--border-strong)",
            color: "var(--text)",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            width: "auto"
          }}
        >
          <h2>Repor produtos no estoque</h2>

          <InputSection>
            <TextField
              fullWidth
              label="Nome do Produto"
              disabled={true}
              value={productName}
              onChange={(e) => setProductName(e.target.value)}
              margin="normal"
            />

            <TextField
              sx={{ width: "50%" }}
              label="Quantidade atual"
              type="number"
              disabled={true}
              value={productQuantity}
              onChange={(e) => setProductQuantity(Number(e.target.value))}
              margin="normal"
            />

            <TextField
              sx={{ width: "50%" }}
              label="Quantidade adicional"
              type="number"
              required
              value={productNewQuantity}
              onChange={(e) => setProductNewQuantity(Number(e.target.value))}
              margin="normal"
            />
          </InputSection>

          <div>
            {productQuantity && productNewQuantity !== 0 && (
              <h2>
                Nova quantidade será:{productQuantity + productNewQuantity}
              </h2>
            )}
          </div>

          <div style={{ marginTop: "20px", textAlign: "right" }}>
            <Button
              onClick={onClose}
              style={{ marginRight: "10px" }}
              color="secondary"
            >
              Cancelar
            </Button>
            <Button onClick={handleSubmit} color="primary" variant="contained">
              Atualizar
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ProductReplanishModal;
